import { createSlice } from '@reduxjs/toolkit';

import { estelamMojadadShakhsSalesKhodro } from 'Feature/Khodro/ShakhsSales/Thunks/estelamMojadadShakhsSalesKhodro';
import { wepodPayOrder } from 'Feature/Orders/Common/Actions/Thunks/wepodPayOrder';
import { PageSizing } from 'Shared/Core/Common/Options/PageSizing';

import { cancelOrder, getAllCartItemsByCurrentUserPaged } from './action';
import { ICartItemsState } from './model';

const initialState: ICartItemsState = {
  cartItems: {
    loading: false,
    data: {
      pageNumber: 0,
      pageSize: PageSizing[1].value as number,
      totalCount: 0,
      queryResult: null,
    },
    queryParams: {
      pageNumber: 1,
      pageSize: 10,
      needTotalCount: true,
      sortAscending: false,
      sortBy: null,
    },
    pagination: {
      currentPage: 1,
      tableColumn: 0,
      totalPage: 0,
      customPageSize: PageSizing[1].value as number,
      firstItemNumber: 0,
      lastItemNumber: 0,
    },
  },
  cancelOrder: {
    loading: false,
    isSuccess: false,
  },
  payOrder: {
    loading: false,
  },
  EstelamMojadadShakhsSales: {
    loading: false,
  },
};

export const cartItemsSlice = createSlice({
  name: 'Order/cartItems',
  initialState,
  reducers: {
    setTotalPage: (state, action) => {
      state.cartItems.pagination.totalPage = action.payload;
    },
    setNextPage: (state) => {
      if (state.cartItems.pagination.currentPage < state.cartItems.pagination.totalPage) {
        state.cartItems.pagination.currentPage = state.cartItems.pagination.currentPage + 1;
        state.cartItems.queryParams.pageNumber = state.cartItems.pagination.currentPage;
      }
    },
    setPervPage: (state) => {
      if (state.cartItems.pagination.currentPage > 1) {
        state.cartItems.pagination.currentPage = state.cartItems.pagination.currentPage - 1;
        state.cartItems.queryParams.pageNumber = state.cartItems.pagination.currentPage;
      }
    },
    setFirstPage: (state) => {
      state.cartItems.pagination.currentPage = 1;
      state.cartItems.queryParams.pageNumber = state.cartItems.pagination.currentPage;
    },
    setEndPage: (state) => {
      state.cartItems.pagination.currentPage = state.cartItems.pagination.totalPage;
      state.cartItems.queryParams.pageNumber = state.cartItems.pagination.currentPage;
    },
    setCurrentPage: (state, action) => {
      state.cartItems.pagination.currentPage = action.payload;
      state.cartItems.queryParams.pageNumber = state.cartItems.pagination.currentPage;
    },
    setCustomPageSize: (state, action) => {
      state.cartItems.pagination.customPageSize = action.payload;
      state.cartItems.queryParams.pageSize = state.cartItems.pagination.customPageSize;
    },
    setFirstItemNumber: (state, action) => {
      state.cartItems.pagination.firstItemNumber = action.payload;
    },
    setLastItemNumber: (state, action) => {
      state.cartItems.pagination.lastItemNumber = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCartItemsByCurrentUserPaged.pending, (state) => {
        state.cartItems.loading = true;
      })
      .addCase(getAllCartItemsByCurrentUserPaged.fulfilled, (state, action) => {
        state.cartItems.loading = false;
        state.cartItems.data = action.payload;
      })
      .addCase(getAllCartItemsByCurrentUserPaged.rejected, (state) => {
        state.cartItems.loading = false;
      });

    builder
      .addCase(cancelOrder.pending, (state) => {
        state.cancelOrder.loading = true;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.cancelOrder.loading = false;
        if (action.payload && action.payload.status === 200) {
          state.cancelOrder.isSuccess = true;
        }
      })
      .addCase(cancelOrder.rejected, (state) => {
        state.cancelOrder.loading = false;
      });

    builder
      .addCase(wepodPayOrder.pending, (state) => {
        state.payOrder.loading = true;
      })
      .addCase(wepodPayOrder.fulfilled, (state) => {
        state.payOrder.loading = false;
      })
      .addCase(wepodPayOrder.rejected, (state) => {
        state.payOrder.loading = false;
      });

    builder
      .addCase(estelamMojadadShakhsSalesKhodro.pending, (state) => {
        state.EstelamMojadadShakhsSales.loading = true;
      })
      .addCase(estelamMojadadShakhsSalesKhodro.fulfilled, (state) => {
        state.EstelamMojadadShakhsSales.loading = false;
      })
      .addCase(estelamMojadadShakhsSalesKhodro.rejected, (state) => {
        state.EstelamMojadadShakhsSales.loading = false;
      });
  },
});

export const {
  setTotalPage,
  setNextPage,
  setPervPage,
  setFirstPage,
  setEndPage,
  setCurrentPage,
  setCustomPageSize,
  setFirstItemNumber,
  setLastItemNumber,
} = cartItemsSlice.actions;

export default cartItemsSlice.reducer;
